import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuth } from "../../BaseQueryWithAuth/baseQueryWithAuth";
import { queryParams } from "../../../utils/helper";

export const pssApiService = createApi({
  reducerPath: "pssApi",
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    getPSSTrack: builder.query({
      query: ({ templateId, params }) => {
        let query = queryParams(params);
        return {
          url: `pss/track/${templateId}${query}`,
          method: "GET",
        };
      },
    }),
    updatePSSTrack: builder.mutation({
      query: ({ payload, params }) => {
        let query = queryParams(params);
        return {
          url: `pss/track${query}`,
          method: "POST",
          body: payload,
        };
      },
    }),
    getCurrentPSS: builder.query({
      query: (params) => {
        let query = queryParams(params);
        return {
          url: `pss/current${query}`,
          method: "GET",
        };
      },
    }),
    updateShowStatus: builder.mutation({
      query: ({ payload, params, id }) => {
        let query = queryParams(params);
        return {
          url: `pss/update-show-status/${id}${query}`,
          method: "PUT",
          body: payload,
        };
      },
    }),
  }),
});

export const {
  useGetPSSTrackQuery,
  useUpdatePSSTrackMutation,
  useGetCurrentPSSQuery,
  useUpdateShowStatusMutation
} = pssApiService;
